// import { useLanguage } from "../utils/languageContext";
import './homepage.css'
import HPHeader from './hpHeader';
import HPOffer from './hpOffer';
import HPAdvantage from './hpAdvantage';
import HPHiw from './hpHiw';
// import HPContact from './hpContact';

const HomePage = () => {
  // const { t } = useLanguage();
  // {t("homepage.header.slogan")}

  return (
    <div className='pageContainer'>
      {/* HEADER SECTION */}
      <HPHeader />

      {/* OUR OFFER */}
      <HPOffer />

      {/* Our Advantages */}
      <HPAdvantage />

      {/* How it works */}
      <HPHiw />

      {/* Contact Form */}
      {/* <HPContact /> */}

    </div>
  );
};

export default HomePage;